import { call, put, select, spawn, takeEvery } from 'redux-saga/effects';
import { hideModal } from 'redux/modules/modals';
import { isLoggedIn } from 'redux/saga/selectors';
import { setCookie } from 'redux/saga/helpers/cookies';
import { gtmSafeRedirect } from 'redux/saga/helpers';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';

export const UPDATE_ACCOUNT_LOCALE = 'UPDATE_ACCOUNT_LOCALE';

export const updateAccountLocale = locale => ({ type: UPDATE_ACCOUNT_LOCALE, locale });

export function* doUpdateAccountLocale(client, { locale }) {
  yield spawn(segment.track, 'Locale Switched', {
    action: 'Changed',
    label: locale,
  });
  yield spawn(segment.track, 'Footer', {
    action: 'Click - Updated Locale',
    label: locale,
  });
  yield spawn(ga, 'Locale Switched', 'Changed', locale);
  yield spawn(ga, 'Footer', 'Click - Updated Locale', locale);
  const loggedIn = yield select(isLoggedIn);
  if (loggedIn) {
    yield call(client.users.updateUserProfile, {
      locale,
    });
  }
  yield put(hideModal('LocaleModal'));
  setCookie('locale', locale, {
    path: '/',
  });
  yield call(gtmSafeRedirect, window.location.href);
}

export function* watchAccountLocaleSagas(client) {
  yield takeEvery(UPDATE_ACCOUNT_LOCALE, doUpdateAccountLocale, client);
}
